import Vue from "vue";
import Base from "./Base.vue";
import * as rules from "vee-validate/dist/rules";
import axios from "axios";
import Raven from "raven-js";
import RavenVue from "raven-js/plugins/vue";
import Notifications from "vue-notification";
import { BootstrapVue } from "bootstrap-vue";
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { setInteractionMode } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

setInteractionMode("lazy");
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);
Vue.use(BootstrapVue);
Vue.use(Notifications);

/**
 * Configure Raven for <www.sentry.io>
 */
Raven.config("https://23ca995b381b4aaea598514780858349@sentry.io/287515", {
  environment: "production",
  whitelistUrls: [
    /prm-dev\.myrecovery\.ai/,
    /prm-staging\.myrecovery\.ai/,
    /prm\.myrecovery\.ai/,
    /dashboard\.msk\.ai/,
    /msk\.ai/,
    /signup\.jointschool\.app/
  ]
})
  .addPlugin(RavenVue, Vue)
  .install();

Vue.config.productionTip = false;

new Vue({
  render: h => h(Base)
}).$mount("#base");
